import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { portalFromPath, useMaintenance } from "../lib/maintenance";
import MaintenanceScreen from "./MaintenanceScreen";

export default function MaintenanceGate({ children }) {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const { cfg, loaded } = useMaintenance();
  const portal = portalFromPath(pathname);
  const isSuper = Boolean(user && user.role === "super_admin");

  if (!portal) return children;

  if (pathname.startsWith("/admin")) {
    if (loading) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#f8f9fa]">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#673c96] border-t-transparent" />
        </div>
      );
    }
    if (isSuper) return children;
  }

  if (!loaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#311b52]">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-white/70 border-t-transparent" />
      </div>
    );
  }

  if (cfg.portals?.[portal]) {
    return <MaintenanceScreen headline={cfg.headline} message={cfg.message} />;
  }
  return children;
}
